import React, { useState } from 'react';

const MAX_404 = 14;

export function NotFoundPage() {
  const [randomNumber] = useState(() => Math.floor(Math.random() * MAX_404) + 1);

  return (
    <div className="row">
      <div className="col-md-10">
        <div className="page-header">
          <h1>404 <small>Page Not Found</small></h1>
        </div>
        <div className="clearfix">
          <img
            className="img-polaroid pull-left"
            style={{ margin: '0 20px 20px 0' }}
            src={`//s3.amazonaws.com/iio-assets/404/404_${randomNumber}.gif`}
            alt="404"
          />
          <div className="alert alert-block alert-warning pull-left">
            <h4>We couldn't find the page that you were looking for</h4>
            <p>If you believe you have reached this page in error, don't hesitate to contact us and let us know.</p>
            <p>
              <button
                type="button"
                className="btn btn-warning"
                onClick={() => (window as any).$zopim?.(
                  () => (window as any).$zopim.livechat.window.show()
                )}
              >
                Contact us
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
